import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = {
  getCaseStudies: () => axios.get(`${API}/case-studies`).then(res => res.data),
  getTestimonials: () => axios.get(`${API}/testimonials`).then(res => res.data),
  getServices: () => axios.get(`${API}/services`).then(res => res.data),
  getInsights: () => axios.get(`${API}/insights`).then(res => res.data),
  getArticles: () => axios.get(`${API}/articles`).then(res => res.data),
  getArticle: (slug) => axios.get(`${API}/articles/${slug}`).then(res => res.data),
  getPopularArticles: (limit = 6) => axios.get(`${API}/articles-popular?limit=${limit}`).then(res => res.data),
  getRelatedArticles: (slug, limit = 3) => axios.get(`${API}/articles-related/${slug}?limit=${limit}`).then(res => res.data),
  getArticleTags: () => axios.get(`${API}/article-tags`).then(res => res.data),
  subscribe: (email) => axios.post(`${API}/subscribers`, { email }).then(res => res.data),
  submitContact: (data) => axios.post(`${API}/contact`, data).then(res => res.data),
  getNewsletterArchive: () => axios.get(`${API}/broadcast-archive`).then(res => res.data),
  getNewsletter: (id) => axios.get(`${API}/broadcast-archive/${id}`).then(res => res.data),
  publicSearch: (q) => axios.get(`${API}/search?q=${encodeURIComponent(q)}`).then(res => res.data),
};
